import React, {  useState } from "react";
import {  openNotification } from "../../utils/helpers";
import { API_BASE_URL } from "../../utils/constants";
import axios, {  } from "axios";
import { useParams, Link, useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import {Form, Button} from "antd";
import http from "../../api/client"; 

function QboAccountSettings({ accountSettings }) {
  const params = useParams();
  const companyId = params.companyId;
  let history = useHistory();
  const [form] = Form.useForm();
  const [manualSyncIsLoading, setManualSyncIsLoading] = useState(false);
  const [responseText, setResponseText] = useState("");

  function manualCustomerSync(e) {
    e.preventDefault();
    setManualSyncIsLoading(true);

    http
      .get(
        API_BASE_URL +
          "/api/qbo/manualCustomerSyncing?companyId=" +
          params.companyId
      )
      .then((res) => {
        setResponseText(res.data?.message);
        setManualSyncIsLoading(false);
        console.log("res.status: ", res.status)
        if(res.status === 200){
          // openNotification('topRight', 'Customers synced successfully!', "Manual sync for customers completed.");
          openNotification('topRight', 'Customers synced successfully!', res.data?.message);
        }else if(res.status === 202){
          openNotification(
            "topRight",
            "Error!",
            res.data?.message,
            "error"
          );

        }else{
          openNotification(
            "topRight",
            "Error!",
            res.data?.message,
            "error"
          );
        }
      })
      .catch((err) => {
        console.log("err in catch of manualCustomerSyncing", err);
        setResponseText("err in catch of manualCustomerSyncing");
        setManualSyncIsLoading(false);
        if(err.response ){
          if(err.response.status === 401 ){
            // console.log("unauthorized in welcome: ",err.response.data.message);
            openNotification(
              "topRight",
              "Unauthorized!",
              err.response.data.message,
              "error"
            );
            history.push("/unAuthorizedUser");
          }
        }
      });
  }

  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 8,
      },
    },
    wrapperCol: {
      xs: {
        span: 16,
      },
      sm: {
        span: 16,
      },
    },
  };

  return (
    <>
      {(accountSettings.companySettings.sync_type === 'manualSync' || accountSettings.companySettings.sync_type === 'both') ?   (
        <div className="bg-white">
          <Form
            {...formItemLayout}
            form={form}
            name="register"
            scrollToFirstError
          >
            <div className="font-raleway ">
              <div className="w-full  grid grid-cols-12 ">
                <div className=" col-span-10 text-lg flex justify-start">
                  <p className="whitespace-pre">
                  Create a new <span className="font-bold">Customer</span> in{" "}
                    <span className="font-bold">QuickBooks Online</span> {" "}
                    when a <span className="font-bold">Customer</span> is created on{" "}
                    <span className="font-bold">Shopify.</span>
                  </p>
                </div>
                
                  <div className="w-full border py-2 px-4 col-span-12 grid grid-cols-12">
                  <div className="col-span-10 flex justify-start">
                <div className="text-left ">
                  <h1 className=" font-bold">Manual Sync:</h1>
                  <p className="">
                    Sync customers manually (Data Sync Limit: 2 Months Old)
                  </p>
                  <div className="">
                    <p className="  whitespace-pre ">
                      Manual Sync will sync existing customers starting
                      <span className="ml-1 font-bold">
                      {moment(accountSettings.companySettings.item_starting_date).format("MM-DD-YYYY").toString()}
                      </span>
                      . You can change the date range from
                    </p>
                    <p className="whitespace-pre  -mt-3 -ml-1 text-left "> the <Link to={params.companyId + "/settings"}>Settings</Link>{" "} 
                    screen in the side menu.{" "}
 </p>
                  </div>
                </div>
              </div>
                    <div className="col-span-2  grid content-end mb-4">
                    <Button
                      loading={manualSyncIsLoading}
                      onClick={(e) => manualCustomerSync(e)}
                      className="h-8 ml-4 px-2 border-2 outline-1 hover:bg-gray-300"
                    >
                      <FontAwesomeIcon icon={faArrowsRotate} className="px-2" />
                      manual sync
                    </Button>
                    </div>
                  </div>
 
                 
              </div>
            </div>
          </Form>
        </div>
      ):
      
      // in case of live sync settings

      <div className="w-full  grid grid-cols-12 ">
      
      
        <div className="w-full border py-2 px-4 col-span-12 grid grid-cols-12">
        <div className="col-span-10 flex justify-start">
      <div className="text-left ">
        <h1 className=" font-bold">Live Sync:</h1>
        <p className=" whitespace-pre">
        Live sync is enabled. Any changes in customer data in <span className="font-bold">Shopify</span>, will sync to{" "}
        <span className="font-bold ">Quickbooks Online</span> instantly.
        </p>
        
      </div>
    </div>
         
        </div>

       
    </div>
      
      
      }
    </>
  );
}

export default QboAccountSettings;
